import SelectField from "../../component/ui/SelectField";
import Button from "component/ui/Button";
import LocationPicker from "component/ui/LocationPicker";
import { gamesSportOptions } from "helper/constant";
import { ListFilter, X } from "lucide-react";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getPlayerList, sendJoinAllCardRequest } from "store/slice/profile";

const ClubCard = () => {
  const dispatch = useDispatch();
  const [selectedSport, setSelectedSport] = useState(null);
  const [dropdown, setDropdown] = useState(false);
  const [selectedClub, setSelectedClub] = useState(null);
  const [isOpen, setIsOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  const [location, setLocation] = useState({
    address: "",
    latitude: null,
    longitude: null,
  });

  const { joinRequestPlayerList } = useSelector((state) => state.profile);
  const clubs = joinRequestPlayerList?.data || [];


  const getAddressFromCoords = async (lat, lng) => {
    if (!window.google || !window.google.maps) return "";

    return new Promise((resolve) => {
      const geocoder = new window.google.maps.Geocoder();
      geocoder.geocode(
        { location: { lat, lng } },
        (results, status) => {
          if (status === "OK" && results?.length) {
            resolve(results[0].formatted_address);
          } else {
            resolve("");
          }
        }
      );
    });
  };


  useEffect(() => {
    navigator.geolocation.getCurrentPosition(
      async (pos) => {
        const lat = pos.coords.latitude;
        const lng = pos.coords.longitude;

        setLocation((prev) => ({
          ...prev,
          latitude: lat,
          longitude: lng,
        }));

        // wait for Google Maps
        setTimeout(async () => {
          const address = await getAddressFromCoords(lat, lng);
          setLocation((prev) => ({
            ...prev,
            address,
          }));
        }, 500);
      },
      () => console.warn("GPS permission denied")
    );
  }, []);


  /* ================= LOCATION ================= */
  useEffect(() => {
    navigator.geolocation.getCurrentPosition((pos) => {
      setLocation({
        address: "",
        latitude: pos.coords.latitude,
        longitude: pos.coords.longitude,
      });
    });
  }, []);

  /* ================= FETCH CLUBS ================= */
  useEffect(() => {
    if (!location.latitude || !location.longitude) return;

    dispatch(
      getPlayerList(
        {
          language: "en",
          page: 1,
          perPage: 10,
          type: "club",
          category: selectedSport || null,
          latitude: location.latitude,
          longitude: location.longitude,
        },
        setLoading
      )
    );
  }, [selectedSport, location.latitude, location.longitude]);

  /* ================= UI ================= */
  return (
    <>
      <div className="min-h-screen bg-gray-50 py-12 px-4">
        <div className="max-w-5xl mx-auto bg-white border shadow">

          {/* Header */}
          <div className="bg-gradient-to-r from-[#2BACE2] to-[#1a8ec4] px-6 py-4">
            <h2 className="text-xl font-semibold text-white">Club Cards</h2>
          </div>

          <div className="p-6 space-y-6">

            {/* Filters */}
            <div className="grid md:grid-cols-2 gap-6">

              <SelectField
                label="Select Sport/Game"
                options={gamesSportOptions}
                value={selectedSport}
                onChange={setSelectedSport}
              />

              <div className="relative flex items-center z-50 overflow-visible">                <div className="w-[90%]">
                <LocationPicker
                  label="Location"
                  placeholder="Search location"
                  value={location.address}
                  onChange={(place) => {
                    if (!place || !place.geometry) {
                      setLocation({
                        address: "",
                        latitude: null,
                        longitude: null,
                      });
                      return;
                    }

                    setLocation({
                      address: place.formatted_address || "",
                      latitude: place.geometry.location.lat(),
                      longitude: place.geometry.location.lng(),
                    });
                  }}
                />

              </div>

                <ListFilter
                  className="w-[10%] mt-5 cursor-pointer"
                  onClick={() => setDropdown(!dropdown)}
                />
              </div>
            </div>

            {/* Cards */}
            <div className="grid md:grid-cols-2 gap-4">
              {clubs.map((club) => (
                <div
                  key={club.id}
                  onClick={() => setSelectedClub(club)}
                  className="p-4 border rounded-lg cursor-pointer hover:border-[#2BACE2]"
                >
                  <p className="font-semibold">{club.name}</p>
                  <p className="text-sm text-gray-600">{club.category}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* ================= MODAL ================= */}
      {selectedClub && (
        <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center">
          <div className="bg-white w-full max-w-lg rounded-xl p-6">

            <div className="flex justify-between items-center mb-4">
              <h3 className="font-semibold text-lg">{selectedClub.name}</h3>
              <X className="cursor-pointer" onClick={() => setSelectedClub(null)} />
            </div>

            <p className="text-sm mb-4">{selectedClub.description || "N/A"}</p>

            <div className="flex justify-between">
              {/* VIEW PROFILE */}
              <Button
                onClick={() =>
                  window.open(
                    `https://web-dev.playmatez.io/club-details/${selectedClub.userId}`,
                    "_blank"
                  )
                }
              >
                View Profile
              </Button>

              {/* SEND REQUEST */}
              <Button
                onClick={() => {
                  dispatch(
                    sendJoinAllCardRequest(
                      {
                        language: "en",
                        cardId: selectedClub.id,
                        cardType: "join",
                      },
                      null,
                      () => setSelectedClub(null)
                    )
                  );
                }}
              >
                Send Request
              </Button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ClubCard;
